export default {"src":"/_next/static/media/icon_law_firms.105a7832.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};